import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

import { unassignedSymbol } from '~/utils'

import { type CustomerAttributeGroupSettingsInputCustomerAttributeGroup } from '../../utils'

const schema = z.object({
  customerAttributes: z.array(
    z.object({
      id: z.string().optional(),
      name: z.string(),
      attachedCustomerAttributeMap: z.record(
        z.string(),
        z.union([z.number(), z.null(), z.literal(unassignedSymbol)]),
      ),
    }),
  ),
}) satisfies z.ZodSchema<{
  customerAttributes: CustomerAttributeGroupSettingsInputCustomerAttributeGroup['customerAttributes']
}>
export type InputValues = z.infer<typeof schema>
export const resolver = zodResolver(schema)
